import React, { useEffect, useState } from 'react';
import { GetAuth } from '../../Auth/AuthProvider';

import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';
import { DataGrid } from '@mui/x-data-grid';
import { Grid, Modal, Box, TextField, Button } from '@mui/material';
import { r2_noHeaderTableUpdate } from '../../Helpers/r2_requests';

import ConstantsAutocomplete from '../CommonComponents/ConstantsAutocomplete';

import ConstantsEdit from './ConstantsEdit';
import { gridStyle } from './gridStyle';

const ConstantsAdmin = () => {
  const [data, setData] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(1);

  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState([]);
  const [loading, setLoading] = useState(false);
  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;
  const [updateData, setUpdateData] = useState(0);
  const [useType, setUseType] = useState(localStorage.getItem('type'));

  //FILTERS
  const [byType, setByType] = useState('');
  const [fullFilterBlob, setFullFilterBlob] = useState([]);

  const [rowData, setRowData] = useState({});

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setForceUpdate(forceUpdate + 1);
  };

  const changeHandler = (event) => {
    let oldData = [...fullFilterBlob];
    let tempData = oldData
      .slice()
      .filter((item) => item.field !== event.target.id);

    // console.log('VALUE', event.target.value);
    setFullFilterBlob([
      ...tempData,
      {
        field: 'name',
        search: event.target.value,
        strict: false,
      },
    ]);

    setByType(event.target.value);
  };

  const handleFilterChange = (data, type) => {
    switch (type) {
      case 'field':
        let oldData = [...fullFilterBlob];
        let tempData = oldData.slice().filter((item) => item.field !== 'field');

        // console.log(data);

        setFullFilterBlob([
          ...tempData,
          {
            field: 'field',
            search: data,
            strict: true,
          },
        ]);
        break;
      default:
        // console.log(data);
        break;
    }
  };

  useEffect(() => {
    // console.log(fullFilterBlob);
    r2_noHeaderTableUpdate(
      {
        resource: `/api/r2_constants`,
        setDataFunc: setData,
        pageNum: page,
        setLoadingFunc: setLoading,
        pagesize: pageSize,
        sorting: sort,
        filtering: filter,
        showNotification: enqNotification,
        setRows: setTotalRows,
        logout,
        fullFilters: fullFilterBlob,
        rangeFilters: [],
      },
      'r2_constants'
    );
  }, [
    page,
    pageSize,
    sort,
    filter,
    updateData,
    enqNotification,
    logout,
    fullFilterBlob,
    forceUpdate,
  ]);

  // console.log(data);
  const columns = [
    {
      field: 'field',
      headerName: 'Type',
      width: 150,
      flex: 1,
      valueGetter: ({ value }) => convert(value),
    },
    { field: 'name', headerName: 'Name', width: 150, flex: 1 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      flex: 1,
      renderCell: (data) => (
        <>
          <Button
            variant='contained'
            size='small'
            onClick={() => {
              setRowData(data.row);
              handleOpen();
            }}
          >
            Edit
          </Button>
        </>
      ),
    },
  ];

  return useType !== 'manager' ? (
    <UnauthorisedAccess />
  ) : (
    <Box style={{ height: '72vh', width: '100%' }}>
      <Box>
        <Grid container>
          <Grid xs={12} md={4}>
            <ConstantsAutocomplete
              id='field'
              nameLabel='Filter By Constant Type'
              setByType={(data) => handleFilterChange(data, 'field')}
            />
          </Grid>
          <Grid xs={12} md={4}>
            <TextField
              sx={{ width: '80%' }}
              id='name'
              label='Filter By Name'
              variant='outlined'
              // value={name}
              onChange={(event) => changeHandler(event)}
            >
              {byType}
            </TextField>
          </Grid>
          <Grid xs={12} md={4}></Grid>
        </Grid>
      </Box>
      <DataGrid
        sx={gridStyle}
        rows={data}
        rowCount={totalRows}
        loading={loading}
        pagination
        sortingMode='server'
        filterMode='server'
        onSortModelChange={(model) => {
          setPage(0);
          setSort(model);
        }}
        onFilterModelChange={(model) => {
          setPage(0);
          setFilter(model.quickFilterValues);
        }}
        page={page}
        pageSize={pageSize}
        paginationMode='server'
        onPageChange={(newPage) => {
          setPage(newPage);
        }}
        onPageSizeChange={(newPageSize) => {
          setPage(0);
          setPageSize(newPageSize);
        }}
        columns={columns}
        onRowClick={(params) => {}}
        onRowDoubleClick={(params) => {
          setRowData(params.row);
          handleOpen();
          // getMyRowData(params.row);
          // setEditOrSave('editMode');
        }}
        rowsPerPageOptions={[25, 50, 100]}
        // components={{ Toolbar: CustomCustomerToolbar }}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        componentsProps={{
          toolbar: {
            updateOnclick: () => {
              setUpdateData((i) => i + 1);
            },
            filterOnClick: () => {
              // handleFilterOpen();
            },
            // modalState: modalState,
          },
        }}
      />

      {/* <DataGrid rows={usersList} columns={columns} /> */}
      <Button
        sx={{ float: 'right', margin: '15px 0 0 0 ' }}
        variant='contained'
        size='small'
        onClick={() => {
          setRowData(newRowData);
          handleOpen();
        }}
      >
        add
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='parent-modal-Time_Attendance'
        aria-describedby='parent-modal-Time_Attendance_Row_Edit'
      >
        <ConstantsEdit thisRowData={rowData} cancelEdit={handleClose} />
      </Modal>
    </Box>
  );
};

export default ConstantsAdmin;

const convert = (data) => {
  switch (data) {
    case 'WARRANTY_FIELDS':
      return 'Warranty';
    case 'CUS_REGIONS':
      return 'Regions';
    case 'CUS_CATEGORIES':
      return 'Categories';
    case 'CUS_ASSET_COMP':
      return 'Asset Comp';

    default:
      return data;
    // break;
  }
};
const newRowData = {
  username: null,
  name: null,
  surname: null,
  contact_number: null,
  email: null,
  permissions: {
    super_admin: true,
  },
  type: 'permanent',
  active: true,
};
